import { extendTheme } from "@chakra-ui/react";
import COLORS from "./colors";

const THEME = extendTheme({
  colors: COLORS,
});

export default THEME;
